import Alpine from 'alpinejs';
import Splide from '../../Helper/NeosSplide';

const defaultOptions = {
    withLightbox: false,
    splide: {
        perPage: 1,
        gap: 20,
        // classes: {
        //     arrow: 'splide__arrow w-12 h-12'
        // }
    }
}

Alpine.data('imageSlider', (options = defaultOptions) => ({
    ...options,

    // Internal Props
    lightboxOpen: false,
    outerSlider: null,
    innerSlider: null,

    get inNeosBackend() {
        return window.name === 'neos-content-main';
    },

    init() {
        this.outerSlider = new Splide(this.$root.querySelector('.image-slider__outer'), {
            ...this.splide,
            drag: !this.inNeosBackend,
            breakpoints: {
                640: {
                    perPage: 1,
                },
                768: {
                    perPage: 2,
                },
            }
        });

        if (this.withLightbox && !this.inNeosBackend) {
            this.innerSlider = new Splide(this.$root.querySelector('.image-slider__inner'), {
                type: 'fade'
            })

            this.outerSlider.on('click', (slide) => {
                this.innerSlider.go(slide.index)
                setTimeout(() => {
                    this.lightboxOpen = true
                }, 100)
            })

            // this.outerSlider.sync(this.innerSlider)
            this.outerSlider.mount();
            this.innerSlider.mount();
        } else {
            this.outerSlider.mount();
        }

        const maxIndex = this.outerSlider.length - 1;
        // this.outerSlider.on('autoplay:playing', (rate) => {
        //     // Go to the first slide after the last slide
        //     if (rate === 1 && maxIndex === this.outerSlider.index) {
        //         this.outerSlider.go(0);
        //     }
        // });
    },

    showLightboxSlide(slideNumber) {
        this.innerSlider.go(slideNumber)
    }
}));
